(function ($) {
    $.fn.copyLinkDocument = function () {
        var $self = $(this);
        var $linkDOMItem = $self.find('.js-copy-link-document-link');
        var $button = $self.find('.js-copy-link-document-button');
        var link = $linkDOMItem.attr('href');
        var doneClass = 'done';
        var doneFlag = false;

        var getFullURL = function (link) {
            var currentURL = new URL(window.location.href);
            return currentURL.origin + link;
        };

        var returnButton = function () {
            if (!doneFlag) {
                return;
            }
            setTimeout(function ()  {
                $button.removeClass(doneClass);
                doneFlag = false;
            }, 3000);
        };

        var init = function () {
            $button.on('click', function () {
                var $temp = $('<input>');
                $('body').append($temp);
                $temp.val(getFullURL(link)).select();
                document.execCommand('copy');
                $temp.remove();
                $(this).addClass(doneClass);
                doneFlag = true;
                returnButton();
            });
        };

        init();
    };
    $('.js-copy-link-document').each(function () {
        $(this).data('copyLinkDocument', $(this).copyLinkDocument());
    });
})(jQuery);
